import styled from 'styled-components';
import { Text } from '../Text';

const StyledContainer = styled.div<{ $gap: number }>`
	display: flex;
	flex-direction: column;
	gap: ${(props) => props.$gap}px;
`;

const StyledHeadContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;

	img {
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 300;
		font-size: 14px;
		line-height: 120%;
		color: #ffffff;
		opacity: 0.5;
	}
`;

const StyledDivider = styled.div`
	width: 100%;
	height: 1px;
	background-color: #d9d9d9;
	opacity: 0.1;
`;

export { StyledContainer, StyledHeadContainer, StyledDivider };
